import Vue from "vue";
import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common["x-uid"] = process.env.VUE_APP_UID;
Vue.prototype.$http = axios;
